import { IRecoverPassword, IUserState } from "./usersState";

export default {
  GET_RECOVER_PASSWORD: (state: IUserState): IRecoverPassword => {
    return state.recoverPassword;
  },
};
